import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon, ArrowDownIcon, ZapIcon, BrainIcon, MoonIcon } from 'lucide-react';
export function Mechanism() {
  return <section className="py-24 px-4 sm:px-6 lg:px-8 relative overflow-hidden" data-id="element-66">
      {/* Subtle indigo glow for the scientific section */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-3xl h-[400px] bg-indigo-600/10 rounded-full blur-[100px] pointer-events-none" data-id="element-67" />

      <div className="max-w-6xl mx-auto relative z-10" data-id="element-68">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16 max-w-3xl mx-auto" data-id="element-69">
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-6" data-id="element-70">
            The Unique Mechanism:
            <br data-id="element-71" />
            <span className="text-indigo-400" data-id="element-72">
              The "Sleep-Pressure" Inverse
            </span>
          </h2>
          <p className="text-slate-300 text-lg leading-relaxed mb-8" data-id="element-73">
            Instead of fighting your brain with willpower, we use a 7-minute
            physiological override. We shift from high-frequency dopamine
            (scrolling) to low-frequency "sleep pressure" by engaging the
            Mammalian Dive Reflex and the Dopamine-Buffer Step-Down.
          </p>
          <p className="font-heading text-xl text-amber-500 font-medium" data-id="element-74">
            No deprivation. No shame. Just biology working for you.
          </p>
        </motion.div>

        {/* Flow Diagram */}
        <div className="flex flex-col md:flex-row items-center justify-center gap-4 md:gap-6 mt-16" data-id="element-75">
          {/* Step 1 */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-navy-800 border border-navy-700 rounded-2xl p-6 w-full md:w-1/3 text-center relative" data-id="element-76">
            <div className="w-12 h-12 mx-auto bg-red-500/10 rounded-full flex items-center justify-center mb-4" data-id="element-77">
              <ZapIcon className="w-6 h-6 text-red-400" data-id="element-78" />
            </div>
            <h3 className="font-heading font-semibold text-white text-lg mb-2" data-id="element-79">
              High Dopamine
            </h3>
            <p className="text-slate-400 text-sm" data-id="element-80">
              Mindless scrolling, anxiety, and artificial wakefulness.
            </p>
          </motion.div>

          {/* Arrow */}
          <motion.div initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="text-indigo-500" data-id="element-81">
            <ArrowRightIcon className="w-8 h-8 hidden md:block" data-id="element-82" />
            <ArrowDownIcon className="w-8 h-8 md:hidden" data-id="element-83" />
          </motion.div>

          {/* Step 2 */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.3
        }} className="bg-indigo-900/40 border border-indigo-500/30 rounded-2xl p-6 w-full md:w-1/3 text-center relative shadow-[0_0_30px_rgba(99,102,241,0.15)]" data-id="element-84">
            <div className="w-12 h-12 mx-auto bg-indigo-500/20 rounded-full flex items-center justify-center mb-4" data-id="element-85">
              <BrainIcon className="w-6 h-6 text-indigo-400" data-id="element-86" />
            </div>
            <h3 className="font-heading font-semibold text-white text-lg mb-2" data-id="element-87">
              7-Min Protocol
            </h3>
            <p className="text-indigo-200 text-sm" data-id="element-88">
              Dopamine-Buffer Step-Down engages physiological override.
            </p>
          </motion.div>

          {/* Arrow */}
          <motion.div initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.4
        }} className="text-amber-500" data-id="element-89">
            <ArrowRightIcon className="w-8 h-8 hidden md:block" data-id="element-90" />
            <ArrowDownIcon className="w-8 h-8 md:hidden" data-id="element-91" />
          </motion.div>

          {/* Step 3 */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.5
        }} className="bg-navy-800 border border-amber-500/30 rounded-2xl p-6 w-full md:w-1/3 text-center relative" data-id="element-92">
            <div className="w-12 h-12 mx-auto bg-amber-500/10 rounded-full flex items-center justify-center mb-4" data-id="element-93">
              <MoonIcon className="w-6 h-6 text-amber-500" data-id="element-94" />
            </div>
            <h3 className="font-heading font-semibold text-white text-lg mb-2" data-id="element-95">
              Deep Sleep Mode
            </h3>
            <p className="text-slate-400 text-sm" data-id="element-96">
              Natural sleep pressure takes over. Fall asleep effortlessly.
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}